/*
 * Copyright 2025 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
@file:Suppress("MatchingDeclarationName")

package cmp.navigation.authenticatednavbar

import androidx.navigation.NavController
import androidx.navigation.NavGraphBuilder
import androidx.navigation.NavOptions
import kotlinx.serialization.Serializable
import studio.oddpods.cauce.core.base.ui.composableWithStayTransitions

@Serializable
data object AuthenticatedNavbarRoute

internal fun NavController.navigateToAuthenticatedNavBar(navOptions: NavOptions? = null) {
    navigate(route = AuthenticatedNavbarRoute, navOptions = navOptions)
}

internal fun NavGraphBuilder.authenticatedNavbarGraph(
    onLogSession: (String) -> Unit = {},
    onNavigateToReminders: () -> Unit = {},
    onNavigateToNotifications: () -> Unit = {},
    onOpenReminders: () -> Unit = {},
    onSendReminder: (String) -> Unit = {},
    onCreateRecurringSchedule: (String) -> Unit = {},
    onEditRecurringSchedule: (String, String) -> Unit = { _, _ -> },
    onSessionClick: (String) -> Unit = {},
) {
    composableWithStayTransitions<AuthenticatedNavbarRoute> {
        AuthenticatedNavbarNavigationScreen(
            onLogSession = onLogSession,
            onNavigateToReminders = onNavigateToReminders,
            onNavigateToNotifications = onNavigateToNotifications,
            onOpenReminders = onOpenReminders,
            onSendReminder = onSendReminder,
            onCreateRecurringSchedule = onCreateRecurringSchedule,
            onEditRecurringSchedule = onEditRecurringSchedule,
            onSessionClick = onSessionClick,
        )
    }
}
